<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import { useAuthStore, authService } from '@adaptcx/shared'

const authStore = useAuthStore()
let stopSessionWatcher: (() => void) | null = null

onMounted(() => {
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark')
  }
})

onMounted(async () => {
  authStore.initFromStorage()
  const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token')
  if (token) {
    try {
      await authStore.fetchUser()
      stopSessionWatcher = authService.startSessionExpiryWatcher()
    } catch (e) {
      console.error('Failed to restore auth state:', e)
    }
  }
})

onUnmounted(() => {
  if (stopSessionWatcher) {
    stopSessionWatcher()
    stopSessionWatcher = null
  }
})
</script>

<template>
  <RouterView />
</template>
